import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { JiraControllerResponse, SupportAccessResponse } from "@ServerTypes/jira/jira.schema";

const ACTION_TO_PATH: Record<string, string> = {
  getList: "getTicketsList",
};

/** Reads a string `action` off an unknown envelope member without asserting its shape. */
function readAction(source: unknown): string | undefined {
  if (typeof source !== "object" || source === null || !("action" in source)) {
    return undefined;
  }
  return typeof source.action === "string" ? source.action : undefined;
}

function resolveJiraPath(data: unknown): string {
  let action: string | undefined;
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    // `FormData.get` yields `string | File | null`; only a JSON string can carry the action.
    const value = data.get("value");
    if (typeof value === "string") {
      try {
        const parsed: unknown = JSON.parse(value);
        action = readAction(parsed);
      } catch {
        action = undefined;
      }
    }
  } else if (typeof data === "object" && data !== null && "value" in data) {
    action = readAction(data.value);
  }
  return `/jira/${(action && ACTION_TO_PATH[action]) || action}`;
}

export const jiraTicketsUrl = `${getBackendUrl()}/jira/getTicketsList`;

export async function fetchIsWhiteListed(): Promise<boolean> {
  const res = await axiosWrapper.get<SupportAccessResponse>(`${getBackendUrl()}/jira/supportAccess`);
  return res.data.isWhiteListed;
}

export async function jiraController(data: unknown) {
  const res = await axiosWrapper.post<JiraControllerResponse>(
    `${process.env.REACT_APP_CUBE_BACKEND}${resolveJiraPath(data)}`,
    data,
  );
  return res;
}
